import { render, staticRenderFns } from "./UiInput.vue?vue&type=template&id=7643a4f6&scoped=true&"
import script from "./UiInput.vue?vue&type=script&lang=js&"
export * from "./UiInput.vue?vue&type=script&lang=js&"
import style0 from "./UiInput.vue?vue&type=style&index=0&id=7643a4f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7643a4f6",
  null
  
)

export default component.exports